import styled from 'styled-components';

interface NextPageProgressBarIndicatorProps {
  percentage: number;
  isDone: boolean;
}

const NextPageProgressBarBase = styled.div<NextPageProgressBarIndicatorProps>`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  height: 4px;
  background-color: ${({ theme }) => theme.colors.interactivePrimary01};
  transform: ${({ percentage }) => `scaleX(${percentage}%)`};
  z-index: 12;
  transition:
    transform 0.3s ease-out,
    opacity 0.3s ${({ isDone }) => (isDone ? '0.3s' : '')} ease-out;
  transform-origin: left;
  opacity: ${({ isDone }) => (isDone ? 0 : 1)};
`;

export { NextPageProgressBarBase };
